import { createContext, ReactNode, useMemo, useState } from 'react';

interface DefaultAccountModalActions {
  readonly open: () => void;
  readonly close: () => void;
}

interface DefaultAccountModalState {
  readonly isOpen: boolean;
}

export const DefaultAccountModalStateCtx =
  createContext<DefaultAccountModalState>({
    isOpen: false,
  });
DefaultAccountModalStateCtx.displayName = 'DefaultAccountModalState';

const throwMissingProvider = () => {
  throw new Error('Missing AccountSelectionProvider upwards in this tree');
};

export const DefaultAccountModalActionsCtx =
  createContext<DefaultAccountModalActions>({
    close: throwMissingProvider,
    open: throwMissingProvider,
  });
DefaultAccountModalActionsCtx.displayName = 'DefaultAccountModalActions';

interface ProviderProps {
  readonly children: ReactNode;
}

export default function AccountSelectionProvider({ children }: ProviderProps) {
  const [isOpen, setIsOpen] = useState(false);

  const state: DefaultAccountModalState = {
    isOpen,
  };

  const methods = useMemo(
    (): DefaultAccountModalActions => ({
      open: () => setIsOpen(true),
      close: () => setIsOpen(false),
    }),
    [],
  );

  return (
    <DefaultAccountModalStateCtx.Provider value={state}>
      <DefaultAccountModalActionsCtx.Provider value={methods}>
        {children}
      </DefaultAccountModalActionsCtx.Provider>
    </DefaultAccountModalStateCtx.Provider>
  );
}
